module.exports = __webpack_public_path__ + "static/media/AgroPack.b4e3eb32.ttf";